// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rrVuH","type":"styles_type__3pc1D","choices":"styles_choices__1KQcT"};